import { ResizerImageProps, resizerImageUrl } from "@uxf/core/utils/resizer";
import { ReactElement } from "react";

const TYPES = ["avif", "webp"];

interface FileResponse {
    extension: string;
    namespace?: string | null;
    uuid: string;
}

export function getImgSrcSet(
    file: FileResponse | undefined,
    width: number | "auto",
    height: number | "auto",
    options: ResizerImageProps = {},
): string | null {
    if (!file || !file.uuid || !file.extension || file.extension === "svg") {
        return null;
    }

    const toFormat = TYPES.includes(file.extension) ? file.extension : "png";

    return [3, 2, 1]
        .map(
            (size) =>
                resizerImageUrl(
                    file,
                    width === "auto" ? "auto" : width * size,
                    height === "auto" ? "auto" : height * size,
                    { toFormat, ...options },
                ) + (size > 1 ? ` ${size}x` : ""),
        )
        .join(", ");
}

export function getImgSources(
    file: FileResponse | undefined,
    width: number | "auto",
    height: number | "auto",
): ReactElement | null {
    if (!file || !file.uuid || !file.extension || file.extension === "svg") {
        return null;
    }

    return (
        <>
            {TYPES.map((type) => (
                <source
                    key={type}
                    srcSet={getImgSrcSet(file, width, height, { toFormat: type }) ?? undefined}
                    type={`image/${type}`}
                />
            ))}
        </>
    );
}
